import React, { useState, useEffect } from 'react';
import '../../../scss/components/pages/staffList.scss';
import swal from 'sweetalert2';

import API from '../../../middleware/API';
import moment from 'moment';
import { lowerCase } from 'lodash';
import axios from 'axios';
import { yearNames } from '../../../const/constant';

const SalaryReceipt = () => {
    const [salaryReceipt, setSalaryReceipt] = useState ({});
    const [annualLeave, setAnnualLeave] = useState ({});
    const [reload, doReload] = useState (false);
    const [date, setDate] = useState(moment().add(-1,'month'));
    useEffect(
    ()=>{
        API.get('Salary/Receipt/'+date.format('YYYY')+'/'+ date.format('MM')).then((res) => {
            if (res) {
                setSalaryReceipt(res)
            }
        }); 
        API.get('Leave/Annual').then((res) => {
            if (res) {
                setAnnualLeave(res)
            }
        }); 
        // axios.all([
        //     API.get('Salary/Receipt/'+date.format('YYYY')+'/'+ date.format('MM')),
        //     API.get('Leave/Annual'),
        //   ]).then(axios.spread((...responses) => {
        //     const salaryRes = responses[0]
        //     const annualLeaveRes = responses[1]
        //     console.log(annualLeaveRes);
            
        //     if (salaryRes) {            
        //         setSalaryReceipt(salaryRes)
        //     }
        //     if (annualLeaveRes) {            
        //         setAnnualLeave(annualLeaveRes)
        //     }
        //     })).catch(errors => {
        //     // react on errors.
        //   })  
    }
    ,[reload, date]);
    var baseSalary = 0;
    if(salaryReceipt.baseSalary){
        baseSalary = salaryReceipt.baseSalary + salaryReceipt.fullAttendance + salaryReceipt.dutyAllowance;
    }else if(salaryReceipt.pay){
        baseSalary = (salaryReceipt.pay * salaryReceipt.workingHours) + salaryReceipt.fullAttendance + salaryReceipt.dutyAllowance;
    }
     
    var unusualSalary = 0;
    if(salaryReceipt.freeTaxOverTime){
        unusualSalary = salaryReceipt.freeTaxOverTime;
    }    
    if(salaryReceipt.performanceBonus){
        unusualSalary = unusualSalary + salaryReceipt.performanceBonus;
    }
    if(salaryReceipt.bonus){
        unusualSalary = unusualSalary + salaryReceipt.bonus;
    }

    var minusItem = 0;
    if(salaryReceipt.laborInsurance){
        minusItem = salaryReceipt.laborInsurance;
    }
    if(salaryReceipt.healthInsurance){
        minusItem = minusItem + salaryReceipt.healthInsurance;
    }
    if(salaryReceipt.personalLeaveSalary){
        minusItem = minusItem + salaryReceipt.personalLeaveSalary;
    }
    if(salaryReceipt.sickLeaveSalary){
        minusItem = minusItem + salaryReceipt.sickLeaveSalary;;
    }
    if(salaryReceipt.lateSalary){
        minusItem = minusItem + salaryReceipt.lateSalary;
    }
    if(salaryReceipt.pointSalary){
        minusItem = minusItem + salaryReceipt.pointSalary;
    }
    if(salaryReceipt.selfPension){
        minusItem = minusItem + salaryReceipt.selfPension;
    }
    if(salaryReceipt.otherDeduction){
        minusItem = minusItem + salaryReceipt.otherDeduction;
    }
    if(salaryReceipt.supplementaryPremium){
        minusItem = minusItem + salaryReceipt.supplementaryPremium;
    }
    const setMonth = (e)=>{
        var newMonth = moment().set('year', date.year()).set('month', e);
        
        setDate(newMonth);
    }
    const setYear = (e)=>{

        var newMonth = moment().set('year', e).set('month', date.month());
        setDate(newMonth);
    }
    console.log(annualLeave.partTimeLeaveHours)
    return(
    <div className="p-staff-list">
    <div className="u-block">
        <div className="u-title">    
        <select onChange={(e)=>{setYear(e.target.value);}} value={date.year()} name="year" id="year"className="" >
        {
                yearNames.map(yearName => (
                  <option key={yearName} value={yearName}>{ yearName }</option>
                ))
              }
        </select>年
        <select onChange={(e)=>{setMonth(e.target.value);}} value={date.month()} name="month" id="month"className="" >
              <option value="0">01</option>
              <option value="1">02</option>
              <option value="2">03</option>
              <option value="3">04</option>
              <option value="4">05</option>
              <option value="5">06</option>
              <option value="6">07</option>
              <option value="7">08</option>
              <option value="8">09</option>
              <option value="9">10</option>
              <option value="10">11</option>
              <option value="11">12</option>
              </select>月薪資單</div>

        <div className="u-table-responsive">
        <table className="u-table u-table-border u-table-striped">
            <thead>
            <tr>
                <th colSpan='2'>固定薪資(A)</th>
                <th colSpan='2'>非固定支付項目(B)</th>
                <th colSpan='2'>應代扣項目(c)</th>
                <th>總計</th>
            </tr>
            </thead>
            <tbody>
                <tr>
                <td>項目</td>
                <td>金額</td>
                <td>項目</td>
                <td>金額</td>
                <td>項目</td>
                <td>金額</td>
                <td rowSpan='4'><textarea name="notes" id="notes" cols="40" rows="5" disabled style={{resize:'none'}} value={salaryReceipt.notes || ''}/></td>
                </tr>
                <tr>
                {
                        salaryReceipt.isPartTime ?
                        <>
                        <td>總時數</td>
                        <td>{salaryReceipt.workingHours}</td>
                        </>
                        :
                        <>
                        <td>底薪</td>
                        <td>{salaryReceipt.baseSalary}</td>
                        </>
                    }

                <td>加班費</td>
                <td>{salaryReceipt.freeTaxOverTime}</td>
                <td>代扣勞保費</td>
                <td>{salaryReceipt.laborInsurance}</td>
                </tr>
                {
                        salaryReceipt.isPartTime ?
                        <tr>
                        <td>時薪</td>
                        <td>{salaryReceipt.pay}</td>
                        <td>獎金</td>
                        <td>{salaryReceipt.performanceBonus}</td>
                        <td>代扣健保費</td>
                        <td>{salaryReceipt.healthInsurance}</td>
                        </tr>
                        :
                        <tr>
                        <td>全勤加給</td>
                        <td>{salaryReceipt.fullAttendance}</td>
                        <td>獎金</td>
                        <td>{salaryReceipt.performanceBonus}</td>
                        <td>代扣健保費</td>
                        <td>{salaryReceipt.healthInsurance}</td>
                        </tr>
                    }

                {
                        salaryReceipt.isPartTime ?
                        <tr>
                        <td>全勤加給</td>
                        <td>{salaryReceipt.fullAttendance}</td>
                        <td>禮金</td>
                        <td>{salaryReceipt.bonus}</td>
                        <td>事假</td>
                        <td>{salaryReceipt.personalLeaveSalary}</td>
                        </tr>
                        :
                        <tr>
                        <td>職務津貼</td>
                        <td>{salaryReceipt.dutyAllowance}</td>
                        <td>禮金</td>
                        <td>{salaryReceipt.bonus}</td>
                        <td>事假</td>
                        <td>{salaryReceipt.personalLeaveSalary}</td>
                        </tr>
                    }
                {
                        salaryReceipt.isPartTime ?
                        <tr>
                        <td>職務津貼</td>
                        <td>{salaryReceipt.dutyAllowance}</td>
                        <td>其他</td>
                        <td>{salaryReceipt.otherAllowance}</td>
                        <td>病假</td>
                <td>{salaryReceipt.sickLeaveSalary}</td>
                <td>職等:{salaryReceipt.jobLevel}</td>

                        </tr>
                        :
                        <tr>
                        <td>伙食津貼</td>
                        <td>{salaryReceipt.foodAllowance}</td>
                        <td>其他</td>
                        <td>{salaryReceipt.otherAllowance}</td>
                        <td>病假</td>
                <td>{salaryReceipt.sickLeaveSalary}</td>
                <td>職等:{salaryReceipt.jobLevel}</td>

                        </tr>
                    }
                                    {
                        salaryReceipt.isPartTime ?
                        <tr>
                        <td>伙食津貼</td>
                        <td>{salaryReceipt.foodAllowance}</td>
                        <td></td>
                        <td></td>
                        <td>遲到</td>
                        <td>{salaryReceipt.lateSalary}</td>
                        <td>漏打卡次數:{salaryReceipt.losePunch}</td>
                        </tr>
                        :
                        <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>遲到</td>
                        <td>{salaryReceipt.lateSalary}</td>
                        <td>漏打卡次數:{salaryReceipt.losePunch}</td>
                        </tr>
                    }
                                    <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>二代健保</td>
                <td>{salaryReceipt.supplementaryPremium}</td>
                <td></td>
                </tr>
                <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>自提勞退</td>
                <td>{salaryReceipt.selfPension}</td>
                <td></td>
                </tr>
                <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>其他扣款</td>
                <td>{salaryReceipt.otherDeduction}</td>
                <td></td>
                </tr>
                <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>扣點單</td>
                <td>{salaryReceipt.pointSalary}</td>
                <td>備註:A+B-C</td>
                </tr>
                <tr>
                <td colSpan='2'>小記(A+B)</td>
                <td colSpan='2'>{salaryReceipt.incomeAmt}</td>
                <td>小記(C)</td>
                <td style={{color:'red'}}>{salaryReceipt.deductionAmt}</td>
                <td>{salaryReceipt.actuallyPaidAmt}</td>
                </tr>
            </tbody>
        </table>
        </div>

    </div>
    {
        annualLeave.id !== 0 &&  !annualLeave.isPartTime?
<div className="u-block">
    <div className="u-title">特別休假</div>
        <div className="u-table-responsive">
        <table className="u-table u-table-border u-table-striped">
            <thead>
                <tr>
                    <th colSpan='2'>特別休假</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td colSpan={2}>請休期間：{moment(annualLeave.sdate).format('YYYY年MM月DD日')} - {moment(annualLeave.eDate).format('YYYY年MM月DD日')}</td>
                </tr>
                {
                    annualLeave.partTimeLeaveHours?
                                <tr>
                                <td>今年可休的特別休假小時數</td>
                                <td>{annualLeave.partTimeLeaveHours}</td>
                            </tr>:
                                <tr>
                                <td>今年可休的特別休假日數</td>
                                <td>{annualLeave.leavesDay}</td>
                            </tr>

                }

                <tr>
                    <td>今年已休的特別休假小時數</td>
                    <td>{annualLeave.takeOffHours}</td>
                </tr>
                {
                    annualLeave.partTimeLeaveHours?
                    <tr>
                    <td>今年未休的特別休假小時數</td>
                    <td>{annualLeave.partTimeLeaveHours + annualLeave.carriedForwardHours- annualLeave.takeOffHours}</td>
                </tr>:
                                                <tr>
                                                <td>今年未休的特別休假小時數</td>
                                                <td>{
                                                annualLeave.leavesDay ?
                                                (annualLeave.leavesDay*8) - annualLeave.takeOffHours + annualLeave.carriedForwardHours
                                            :
                                            ''}</td>
                                            </tr>

                }

                <tr>
                    <td>今年特別休假的請假日期</td>
                    <td>{
                        annualLeave.appliedLeaves ?
                        annualLeave.appliedLeaves.map((leave)=>{
                            return (
                                <div key={leave.id}>
                                    <span>{moment(leave.sDate).format('YYYY年MM月DD日 HH點mm分')}~{moment(leave.eDate).format('YYYY年MM月DD日 HH點mm分')}</span>
                                  <br/>
                                </div>

                            );
                        })
                        :
                        ''
                    }</td>
                </tr>
            </tbody>
        </table>
        </div>

    </div>
        :
        !annualLeave.isPartTime ?
        
        <div className="u-block">
    <div className="u-title">特別休假</div>
        <div className="u-table-responsive">
        <table className="u-table u-table-border u-table-striped">
            <thead>
                <tr>
                    <th colSpan='2'>特別休假</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>請休期間：未滿半年</td>
                </tr>
                <tr>
                    <td>今年可休的特別休假日數</td>
                    <td>0</td>
                </tr>
                <tr>
                    <td>今年已休的特別休假小時數</td>
                    <td>0</td>
                </tr>
                <tr>
                    <td>今年未休的特別休假小時數</td>
                    <td>0</td>
                </tr>
                <tr>
                    <td>今年特別休假的請假日期</td>
                    <td>0</td>
                </tr>
            </tbody>
        </table>
        </div>

    </div>:''
    }
        </div>

    );

}

export default SalaryReceipt

